import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismViewSwitcher } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import hasFeature from 'lumen/helpers/has-feature';

interface ParityButtonGroupSignature {
  Args: {};
}

export default class ParityButtonGroup extends Component<ParityButtonGroupSignature> {
  @service declare access: Services['access'];
  @service declare router: Services['router'];
  @service declare usageAnalytics: Services['usage-analytics'];

  /*
   * There are 3 possible views for parity:
   * - Parity Chart View --> hasParityAnalytics || hasParityOverview
   * - Parity Table View (default) --> hasParityAnalytics || hasParityOverview || hasFeature('subscription.parity.pos')
   * - Parity POS View --> hasFeature('subscription.parity.pos')
   * If only parity table view is available, we don't show the button group
   */
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isVisible() {
    return (
      this.access.hasParityAnalytics ||
      this.access.hasParityOverview ||
      this.access.hasFeature('subscription.parity.pos')
    );
  }

  @action switchTab(viewSwitcherButtonId: string): void {
    this.usageAnalytics.track('Data Visualisation Changed', {
      eventTrigger: 'filter-bar',
      from: this.router.currentRouteName,
      to: viewSwitcherButtonId,
    });

    this.router.transitionTo(viewSwitcherButtonId);
  }

  <template>
    {{#if this.isVisible}}
      <PrismViewSwitcher
        {{! @glint-expect-error: Type 'string | null' is not assignable to type 'string'. }}
        @activeButtonId={{this.router.currentRouteName}}
        @onSetActiveButtonId={{this.switchTab}}
        as |ViewSwitcher|
      >
        {{#if this.access.hasParityAnalytics}}
          <ViewSwitcher.button
            @icon="view-chart"
            @id="hotel.parity.insight.index"
            @label=""
          />
        {{else if this.access.hasParityOverview}}
          <ViewSwitcher.button
            @icon="view-chart"
            @id="hotel.parity.overview"
            @label=""
          />
        {{/if}}
        {{#if
          (or
            (hasFeature "subscription.parity.pos")
            this.access.hasParityOverview
            this.access.hasParityAnalytics
          )
        }}
          <ViewSwitcher.button
            @icon="view-table"
            @id="hotel.parity.list"
            @label=""
          />
        {{/if}}
        {{#if (hasFeature "subscription.parity.pos")}}
          <ViewSwitcher.button
            @icon="events-global"
            @id="hotel.parity.pos"
            @label=""
          />
        {{/if}}
      </PrismViewSwitcher>
    {{/if}}
  </template>
}
